// import { AutoWebViewJs, autoWebViewJs } from "@droid/android/android/AutoWebViewJs"
import { AutoWebViewJs, autoWebViewJs } from "@droid/android"
import { isRealInAndroid } from "@droid/android"
import { mockWebView } from "@droid/android"


let androidIsInitialized = false
export async  function initAndroid(){
    if(androidIsInitialized) return
    if(!isRealInAndroid){
        mockWebView()
    } 
    new AutoWebViewJs();
    await autoWebViewJs.init()
    androidIsInitialized = true
}